import React, {useContext} from 'react';
import {LanguageContext} from "../../platform/i18n/i18n";

const LANGUAGES = ["pl", "en", "de", "ru"];

/**
 * Language switcher for the unauthenticated auth screens (sign-in, registration, password reset).
 * Mirrors the in-layout LanguageSelector but styled for a light card background.
 * Switching persists the language and reloads the page (handled by LanguageContext.updateLanguage).
 */
export function AuthLanguageSwitcher() {
    const {currentLanguage, updateLanguage} = useContext(LanguageContext);

    const buttonClass = (language: string) =>
        "btn btn-sm me-1 " + (language === currentLanguage ? "btn-primary" : "btn-outline-secondary");

    return <div className="text-center mb-3">
        {LANGUAGES.map(language =>
            <button key={language} type="button" className={buttonClass(language)} onClick={() => updateLanguage(language)}>
                {language.toUpperCase()}
            </button>
        )}
    </div>;
}
